import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader, Chip } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
import { getAllLatePolicyConfigurations } from "./Component/api";

const LatePolicyConfiguration = () => {
  const navigate = useNavigate();
  const { user, AccessData } = useContext(UserDetailsContext);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [policyList, setPolicyList] = useState([]);

  useEffect(() => {
    fetchPolicies();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Policy Name",
      flex: 1.5,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "employeeType",
      headerName: "Employee Type",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      renderCell: (params) => params.value || "All",
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      renderCell: (params) => params.value || "All",
    },
    {
      field: "slabCount",
      headerName: "Slabs",
      flex: 0.5,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "isActive",
      headerName: "Status",
      flex: 0.7,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Active" : "Inactive"}
          color={params.value ? "success" : "default"}
          size="small"
          variant="outlined"
        />
      ),
    },
  ];

  const rows = (policyList || []).map((p) => ({
    id: p.id,
    name: p.name,
    employeeType: p.employeeType,
    category: p.category,
    slabCount: p.slabs ? p.slabs.length : 0,
    isActive: p.isActive,
  }));

  const handleNewPolicy = () => {
    navigate("/late-policy-configuration/add");
  };

  const onRowClick = (e) => {
    if (e?.id) {
      navigate(`/late-policy-configuration/add?id=${e.id}`);
    }
  };

  const fetchPolicies = async () => {
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        { query: getAllLatePolicyConfigurations },
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response.data.data.allLatePolicyConfigurations;
      setPolicyList(data);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("Error fetching late policies:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Late Policy Configuration
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  Configure slab-based late penalties for payroll deductions
                </MaterialTypography>
              </Stack>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={handleNewPolicy}
              >
                Add Policy
              </MaterialButton>
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRowClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No late policies configured
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  Click "Add Policy" to create a late policy configuration.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default LatePolicyConfiguration;
